import { TranslatableKey } from '@app/types/translatable.type';

export const RemitterTypes: { [key: string]: TranslatableKey } = {
    quarterly: 'company.payroll-info-cra-form.quarterly',
    monthly: 'company.payroll-info-cra-form.monthly',
    threshold_1: 'company.payroll-info-cra-form.threshold1',
    threshold_2: 'company.payroll-info-cra-form.threshold2',
};
